import axios from 'axios';
import { cacheConfig, http } from '../helpers/axiosHelper';
axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('bearerToken');

export default class JourneyTypeService {
   async getJourneyTypes() {
      return http.get(import.meta.env.VITE_APP_API_BASE_URL_DATA + '/journey-type', { ...cacheConfig }).then((response) => {
         return response.data;
      });
   }
}
